module.exports = __webpack_public_path__ + "static/media/mira_search_thumb.40f770ff.png";